import { Routes, Route, Navigate } from 'react-router-dom';
import ProductFormNew from './ProductFormNew';
import { Element } from './Element';
const ProductRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Element />} />
      <Route path="/new" element={<ProductFormNew />} />
      <Route path="/edit/:id" element={<ProductFormNew />} />
    </Routes>
  );
};

export default ProductRoutes; 